/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from "axios";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = format || this.format || undefined;
            if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
                body = this.createFormData(body);
            }
            if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
                body = JSON.stringify(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (requestParams.headers || {})), (type && type !== ContentType.FormData ? { "Content-Type": type } : {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: axiosConfig.baseURL || "https://6pctmc7iq3.execute-api.eu-west-1.amazonaws.com/{basePath}" }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, ((method && this.instance.defaults.headers[method.toLowerCase()]) || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
}
/**
 * @title motor-damages-private-api
 * @version 0.0.8
 * @baseUrl https://6pctmc7iq3.execute-api.eu-west-1.amazonaws.com/{basePath}
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.healthCheck = {
            /**
             * No description
             *
             * @tags public, health-check
             * @name HealthCheckGet
             * @request GET:/health-check
             */
            healthCheckGet: (params = {}) => this.request(Object.assign({ path: `/health-check`, method: "GET", format: "json" }, params)),
        };
        this.smartphotos = {
            /**
             * @description Sign images of damages
             *
             * @tags images
             * @name ImagesSignPost
             * @summary Sign images of damages
             * @request POST:/smartphotos/{smartphoto_id}/damages/signed-images
             * @secure
             */
            imagesSignPost: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/signed-images`, method: "POST", body: data, secure: true, type: ContentType.Json, format: "json" }, params)),
            /**
             * No description
             *
             * @tags images
             * @name ImagesOptions
             * @summary CORS support
             * @request OPTIONS:/smartphotos/{smartphoto_id}/damages/signed-images
             */
            imagesOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/signed-images`, method: "OPTIONS" }, params)),
            /**
             * @description Create smartphoto damages
             *
             * @tags damages
             * @name DamagesPost
             * @summary Create smartphoto damages
             * @request POST:/smartphotos/{smartphoto_id}/damages
             * @secure
             */
            damagesPost: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages`, method: "POST", body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * @description Get smartphoto damages
             *
             * @tags damages
             * @name DamagesGet
             * @summary Get smartphoto damages
             * @request GET:/smartphotos/{smartphoto_id}/damages
             * @secure
             */
            damagesGet: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * @description Updates smartphoto damages
             *
             * @tags damages
             * @name DamagesPatch
             * @summary Updates smartphoto damages
             * @request PATCH:/smartphotos/{smartphoto_id}/damages
             * @secure
             */
            damagesPatch: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages`, method: "PATCH", body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * @description Delete all damages og smartphoto
             *
             * @tags damages
             * @name DamagesDeleteAll
             * @summary Delete all damages og smartphoto
             * @request DELETE:/smartphotos/{smartphoto_id}/damages
             * @secure
             */
            damagesDeleteAll: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages`, method: "DELETE", secure: true }, params)),
            /**
             * No description
             *
             * @tags damages
             * @name DamagesOptions
             * @summary CORS support
             * @request OPTIONS:/smartphotos/{smartphoto_id}/damages
             */
            damagesOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages`, method: "OPTIONS" }, params)),
            /**
             * @description Delete a damage
             *
             * @tags damages
             * @name DamagesDelete
             * @summary Delete a damage
             * @request DELETE:/smartphotos/{smartphoto_id}/damages/{id}
             * @secure
             */
            damagesDelete: (smartphotoId, id, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/${id}`, method: "DELETE", secure: true }, params)),
            /**
             * No description
             *
             * @tags damages
             * @name DamagesDeleteOptions
             * @summary CORS support
             * @request OPTIONS:/smartphotos/{smartphoto_id}/damages/{id}
             */
            damagesDeleteOptions: (smartphotoId, id, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/${id}`, method: "OPTIONS" }, params)),
            /**
             * @description Accept a damage by a agent
             *
             * @tags damages
             * @name DamagesAcceptedPost
             * @summary Accept a damage by a agent
             * @request POST:/smartphotos/{smartphoto_id}/damages/{id}/accepted
             * @secure
             */
            damagesAcceptedPost: (smartphotoId, id, data, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/${id}/accepted`, method: "POST", body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags damages
             * @name DamagesAcceptedPostOptions
             * @summary CORS support
             * @request OPTIONS:/smartphotos/{smartphoto_id}/damages/{id}/accepted
             */
            damagesAcceptedPostOptions: (smartphotoId, id, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/${id}/accepted`, method: "OPTIONS" }, params)),
            /**
             * @description Rejected a damage by a agent
             *
             * @tags damages
             * @name DamagesRejectedPost
             * @summary Rejected a damage by a agent
             * @request POST:/smartphotos/{smartphoto_id}/damages/{id}/rejected
             * @secure
             */
            damagesRejectedPost: (smartphotoId, id, data, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/${id}/rejected`, method: "POST", body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags damages
             * @name DamagesRejectedPostOptions
             * @summary CORS support
             * @request OPTIONS:/smartphotos/{smartphoto_id}/damages/{id}/rejected
             */
            damagesRejectedPostOptions: (smartphotoId, id, params = {}) => this.request(Object.assign({ path: `/smartphotos/${smartphotoId}/damages/${id}/rejected`, method: "OPTIONS" }, params)),
        };
    }
}
